import logoMark from "./sr-logo-mark.png";

// SDR ReachOut brand mark (the "SR" arrow icon from the official logo),
// rendered exactly as designed (full multi-tone shading — do not recolor
// or flatten it). Used anywhere the icon badge appears (sidebar, login,
// landing page, plan selection, logout modal) so the icon stays identical
// everywhere instead of being redrawn per-page.
export default function AppLogo({ size = 34, radius, style = {} }) {
  return (
    <img
      src={logoMark}
      alt="SDR ReachOut"
      width={size}
      height={size}
      style={{ flexShrink: 0, borderRadius: radius, objectFit: "contain", ...style }}
    />
  );
}
